<template>
  <div class="shoppe">
    <div class="query-form">
      <el-form label-position="right" label-width="140px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="专柜名称">
                  <el-select v-model="queryForm.stockLocationId" filterable clearable>
                    <el-option v-for="item in stockLocationList" :key="item.stockLocationId" :value="item.stockLocationId" :label="item.stockLocation"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="关联店铺别名">
                  <el-select v-model="queryForm.vendorAliasId" filterable clearable>
                    <el-option v-for="item in vendorList" :key="item.vendorId" :value="item.vendorId" :label="item.vendorNameAlias"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="关联店铺名称">
                  <el-select v-model="queryForm.vendorId" filterable clearable>
                    <el-option v-for="item in vendorList" :key="item.vendorId" :value="item.vendorId" :label="item.vendorName"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="结算货币单位">
                  <el-select v-model="queryForm.payCurrencyUnit" clearable>
                    <el-option v-for="item in unitList" :key="item.productExchangeRateId" :label="item.fromCountry" :value="item.fromCountry"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="是否使用退税公司">
                  <el-select v-model="queryForm.taxRefundCompany" clearable>
                    <el-option label="否" :value="0"></el-option>
                    <el-option label="是" :value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="退税公司">
                  <el-select v-model="queryForm.merchantTaxRefundCompanyId" filterable clearable>
                    <el-option v-for="item in taxRefundCompanyList" :key="item.merchantTaxRefundCompanyId" :value="item.merchantTaxRefundCompanyId" :label="item.taxRefundCompanyName"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="买手佣金比例">
                  <input-range symbol="%" v-model="commissionRatioRange"></input-range>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="返点比例">
                  <input-range symbol="%" v-model="rebatesRatioRange"></input-range>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="预付款余额">
                  <input-range v-model="balanceRange"></input-range>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="积分/返点折现余额">
                  <input-range v-model="rebatesBalanceRange"></input-range>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="充值提醒金额">
                  <input-range v-model="remindBalanceRange"></input-range>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="tr">
      <el-button type="primary" @click="$router.push({ path: '/merchant/account/create' })">创建</el-button>
    </div>
    <el-table :data="tableData">
      <el-table-column prop="merchantAccountId" label="ID"></el-table-column>
      <el-table-column prop="stockLocation" label="专柜名称"></el-table-column>
      <el-table-column prop="vendorName" label="关联店铺名称">
        <template slot-scope="scope">
          {{ scope.row.vendorName }}
          <p>/</p>
          {{ scope.row.vendorNameAlias }}
        </template>
      </el-table-column>
      <el-table-column prop="payCurrencyUnit" label="结算货币单位"></el-table-column>
      <el-table-column label="是否使用退税公司">
        <template slot-scope="scope">
          {{ scope.row.taxRefundCompany === 1 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column prop="taxRefundCompanyName" label="退税公司">
        <template slot-scope="scope">
          {{ scope.row.taxRefundCompanyName || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="买手佣金比例">
        <template slot-scope="scope">
          {{ scope.row.commissionRatio != null ? scope.row.commissionRatio + '%' : '-' }}
        </template>
      </el-table-column>
      <el-table-column label="返点比例">
        <template slot-scope="scope">
          {{ scope.row.rebateRatio != null ? scope.row.rebateRatio + '%' : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="balance" label="预付款余额">
        <template slot-scope="scope">
          {{ scope.row.balance || '0' }}
        </template>
      </el-table-column>
      <el-table-column prop="rebateBalance" label="积分/返点折现余额">
        <template slot-scope="scope">
          {{ scope.row.rebateBalance || '0' }}
        </template>
      </el-table-column>
      <el-table-column prop="rechargeRemindAmount" label="充值提醒金额">
        <template slot-scope="scope">
          {{ scope.row.rechargeRemindAmount || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-link type="primary" @click="editItem(scope.row)">修改配置</el-link>
          <el-link type="primary" class="ml10" @click="recharge(scope.row)">预付款充值</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <el-dialog append-to-body title="预付款充值" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item prop="amount" label="充值金额" :rules="[
          { required: true, message: '请输入充值金额' },
          { pattern: /^\d+$/, message: '金额必须是整数' },
          { type: 'number', min: 1, max: 100000000000, message: '金额必须大于0' },
        ]">
          <el-input v-model.number="form.amount"></el-input>
        </el-form-item>
        <el-form-item prop="accountName" label="充值渠道">对公转账</el-form-item>
        <el-form-item prop="bankName" label="支付银行" :rules="[{ required: true, message: '请输入支付银行' }]">
          <el-input v-model="form.bankName" :maxlength="50"></el-input>
        </el-form-item>
        <el-form-item prop="bankName" label="银行账号" :rules="[{ required: true, message: '请输入银行账号' }]">
          <el-input v-model="form.bankCard" :maxlength="50"></el-input>
        </el-form-item>
        <el-form-item prop="serialNumber" label="流水号" :rules="[{ required: true, message: '请输入流水号' }]">
          <el-input v-model="form.serialNumber" :maxlength="70"></el-input>
        </el-form-item>
        <el-form-item prop="payCertificate" label="充值凭证" :rules="[{ required: true, message: '请上传充值凭证' }]">
          <el-upload class="upload-el" action="" multiple drag :limit="10" :http-request="handleHttpRequest" accept=".png,.jpg,.jpeg,.pdf,.xls,.xlsx" :on-success="handleSuccess" :on-remove="onRemove" :on-exceed="onExceed">
            <div class="upload-box">
              <i class="el-icon-upload icon"></i>
              <p class="mt20">点击或将文件拖拽到这里上传</p>
              <p class="mt10">( 支持格式 jpg, jpeg, png, pdf, xls, xlsx )</p>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确认充值</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {
  getMerchantTaxRefundCompanyList,
  getMerchantStockLocationList,
  getVendorsByVendorName,
  getMerchantAccountList,
  merchantAccountRecharge,
  fileUpload
} from "../../api/merchants";
import {
  getUnitList,
} from '../buyershop/api';
import Client from "@/utils/client.js";
import InputRange from './InputRange.vue';

export default {
  components: {
    InputRange,
  },
  data() {
    return {
      taxRefundCompanyList: [],
      stockLocationList: [],
      vendorList: [],
      commissionRatioRange: [],
      rebatesRatioRange: [],
      balanceRange: [],
      rebatesBalanceRange: [],
      remindBalanceRange: [],
      queryForm: {
        stockLocationId: null,
        vendorAliasId: null,
        vendorId: null,
        payCurrencyUnit: null,
        taxRefundCompany: null,
        merchantTaxRefundCompanyId: null,
        pageNo: 1,
        pageSize: 25,
      },
      unitList: [],
      tableData: [],
      total: 0,
      dialogVisible: false,
      form: {
        merchantAccountId: null,
        payType: 1, // 1对公转账
        bankName: null,
        serialNumber: null,
        amount: null,
        payCertificate: [],
        bankCard: null,
      },
    };
  },
  mounted() {
    getMerchantStockLocationList().then(res => {
      this.stockLocationList = res.data.data || [];
    })
    getVendorsByVendorName().then(res => {
      this.vendorList = res.data || [];
    })
    getMerchantTaxRefundCompanyList().then(res => {
      this.taxRefundCompanyList = res.data.data || [];
    })
    getUnitList().then(res => {
      this.unitList = res.data.data || [];
    })
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.stockLocationId = null;
      this.queryForm.vendorAliasId = null;
      this.queryForm.vendorId = null;
      this.queryForm.payCurrencyUnit = null;
      this.queryForm.taxRefundCompany = null;
      this.queryForm.merchantTaxRefundCompanyId = null;
      this.commissionRatioRange = [];
      this.rebatesRatioRange = [];
      this.balanceRange = [];
      this.rebatesBalanceRange = [];
      this.remindBalanceRange = [];
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      getMerchantAccountList({
        ...this.queryForm,
        vendorId: this.queryForm.vendorAliasId || this.queryForm.vendorId,
        commissionRatioStart: this.commissionRatioRange[0],
        commissionRatioEnd: this.commissionRatioRange[1],
        balanceStart: this.balanceRange[0],
        balanceEnd: this.balanceRange[1],
        rebateRatioStart: this.rebatesRatioRange[0],
        rebateRatioEnd: this.rebatesRatioRange[1],
        rebateBalanceStart: this.rebatesBalanceRange[0],
        rebateBalanceEnd: this.rebatesBalanceRange[1],
        rechargeRemindAmountStart: this.remindBalanceRange[0],
        rechargeRemindAmountEnd: this.remindBalanceRange[1],
      }).then(res => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.list;
        }
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    editItem(row) {
      this.$router.push({
        path: `/merchant/account/edit/${row.merchantAccountId}`
      });
    },
    recharge(row) {
      this.form.merchantAccountId = row.merchantAccountId;
      this.form.bankName = null;
      this.form.serialNumber = null;
      this.form.amount = null;
      this.form.payCertificate = [];
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
    },
    handleSuccess(res, file, fileList) {
      this.form.payCertificate = fileList;
      this.$refs.form.clearValidate('payCertificate');
    },
    handleHttpRequest(option) {
      return fileUpload().then(res => {
        const client = Client(res.data.data), file = option.file;
        const random_name = new Date().getTime() + Math.random().toString() + '.' + file.name.split('.').pop();
        return client.put('tmp/' + random_name, file);
      });
    },
    onExceed() {
      this.$message('最多只能上传10个文件');
    },
    onRemove(file, fileList) {
      this.form.payCertificate = fileList;
    },
    submit() {
      if (this.repeatSave) {
        return;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.repeatSave) {
            return;
          }
          this.repeatSave = true;
          const payCertificate = JSON.stringify(this.form.payCertificate.map(item => {
            if (item.response) {
              return {
                name: item.name,
                url: item.response.url,
              }
            }
            return {
              name: item.name,
              url: item.url,
            }
          }));
          merchantAccountRecharge({
            ...this.form,
            payCertificate,
          }).then(res => {
            this.repeatSave = false;
            if (res.data.success) {
              this.$message.success('创建成功');
              this.dialogVisible = false;
              this.getTableData();
            } else {
              this.$message.error(res.data.data || res.data.message);
            }
          }).catch((err) => {
            this.repeatSave = false;
          })
        } else {
          this.$message.error('请完善信息');
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.upload-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 15px;
  padding-bottom: 25px;
  color: #999;
  font-size: 12px;
  line-height: 1;

  .icon {
    color: #aaa;
    font-size: 50px;
  }
  .mt10 {
    margin-top: 10px;
  }
  .mt20 {
    margin-top: 20px;
  }
}
</style>
<style lang="less">
.upload-el {
  .el-upload--text {
    display: block;
  }
  .el-upload-dragger {
    width: auto;
    height: auto;
  }
  .el-icon-upload {
    margin: 0;
  }
}
</style>
